module.exports = __webpack_public_path__ + "static/media/alexandra-daddario-win.f5194c80.jpg";